/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {BreadcrumbActions} from '@ion/dls/src/types/types';
import {selectedAssetSelector} from '@/store/selectors/tracking-selectors';
import {BreadcrumbsType} from '@/types/sidesheet';

/**
 * @useRootCrumb
 * React Hook to create an root assets/device crumb
 *
 *  ```typescript
 *   import {useRootCrumb} from '@/routes/tracking/hooks';
 *
 *   const [rootCrumb] = useRootCrumb();
 *  ```
 */
export const useRootCrumb = () => {
  const initialCrumb = useMemo(() => ({
    label : translate('common:entityLabels.asset'),
    click : BreadcrumbActions.rootClick
  }), []);
  const [crumbs, setCrumbs] = useState<BreadcrumbsType>(initialCrumb);
  const selectedAsset       = useSelector(selectedAssetSelector);

  useEffect(() => {
    if (selectedAsset?.isScDevice() && !selectedAsset.getAssetName()) {
      const crumb = {...crumbs};
      setCrumbs({
        ...crumb,
        label : translate('common:entityLabels.device')
      });
    } else {
      setCrumbs(initialCrumb);
    }
  }, [selectedAsset]);
  return [crumbs];
};
